import { AwaitingReviewCard } from '../../components/identities/AwaitingReviewCard';
import { useSaasLinks } from '../../hooks/use-saas-links';

export function AwaitingReviewPage(): JSX.Element {
  const query = useSaasLinks({ confidence: 'awaiting_review' });
  const items = query.data?.items ?? [];

  return (
    <div className="mx-auto flex max-w-5xl flex-col gap-6 px-6 py-6">
      <header>
        <h1 className="text-2xl font-semibold tracking-tight text-ink">
          Vínculos aguardando revisão
        </h1>
        <p className="mt-1 text-sm text-muted">
          Matching de webhook/bootstrap encontrou candidato com score entre 40 e 89. Decida
          confirmar, rejeitar ou criar cliente novo.
        </p>
      </header>

      {query.isLoading && (
        <div className="rounded-[12px] border border-line bg-panel py-12 text-center text-sm text-muted">
          Carregando vínculos…
        </div>
      )}

      {query.isError && (
        <div className="rounded-[12px] border border-bad/40 bg-bad/10 p-4 text-sm text-ink">
          Erro ao carregar fila de revisão.
        </div>
      )}

      {query.data && items.length === 0 && (
        <div className="rounded-[12px] border border-good/40 bg-good/10 py-12 text-center text-sm text-ink">
          ✅ Nenhum vínculo aguardando revisão.
        </div>
      )}

      <div className="flex flex-col gap-4">
        {items.map((link) => (
          <AwaitingReviewCard key={link.id} link={link} />
        ))}
      </div>
    </div>
  );
}
